import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

const KEY = "l4c_sidebar_collapsed";

export const AppLayout = () => {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem(KEY) === "1");
  const toggle = () => {
    setCollapsed((c) => {
      localStorage.setItem(KEY, c ? "0" : "1");
      return !c;
    });
  };

  return (
    <div className="min-h-screen bg-[#0a1425] text-slate-200">
      <Sidebar collapsed={collapsed} onToggle={toggle} />
      <div className={`transition-[padding] duration-300 ${collapsed ? "md:pl-20" : "md:pl-64"}`}>
        <Topbar />
        <main className="px-4 sm:px-8 py-6 sm:py-8 max-w-[1600px]">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
